import React from "react";
import { Check } from "lucide-react";
import { weatherStyleColorForInput } from "../../utils/weatherWidgetStyle";

/**
 * @param {object} props
 * @param {string} props.variant
 * @param {Record<string, unknown>} props.style
 * @param {string} props.city
 * @param {string} props.lat
 * @param {string} props.lng
 * @param {string} props.unit
 * @param {(patch: Record<string, unknown>) => void} props.onPatch
 * @param {() => void} [props.onLocationCommit]
 */
export default function WeatherWidgetStylePanel({
  variant,
  style,
  city,
  lat,
  lng,
  unit,
  onPatch,
  onLocationCommit,
}) {
  const s = style || {};

  const rowColor = (label, key) => (
    <div className="de-rs-row" key={key} style={{ alignItems: "center", marginBottom: 8 }}>
      <label className="de-rs-inline-label" style={{ minWidth: 100, fontSize: 12 }}>
        {label}
      </label>
      <input
        type="color"
        value={weatherStyleColorForInput(s[key], "#ffffff")}
        onChange={(e) => onPatch({ style: { [key]: e.target.value } })}
        style={{
          width: 36,
          height: 28,
          border: "none",
          padding: 0,
          cursor: "pointer",
          borderRadius: 4,
        }}
      />
    </div>
  );

  const isMetric = unit !== "imperial";

  return (
    <>
      <div className="de-rs-section">
        <span className="de-rs-section-label">Location</span>
        <div className="de-rs-field" style={{ marginBottom: 8 }}>
          <label>City</label>
          <input
            type="text"
            value={city || ""}
            placeholder="e.g. Stockholm"
            onChange={(e) => onPatch({ city: e.target.value })}
            onBlur={() => onLocationCommit?.()}
          />
        </div>
        <div className="de-rs-row">
          <div className="de-rs-field">
            <label>Latitude</label>
            <input
              type="text"
              value={lat ?? ""}
              onChange={(e) => onPatch({ lat: e.target.value })}
              onBlur={() => onLocationCommit?.()}
            />
          </div>
          <div className="de-rs-field">
            <label>Longitude</label>
            <input
              type="text"
              value={lng ?? ""}
              onChange={(e) => onPatch({ lng: e.target.value })}
              onBlur={() => onLocationCommit?.()}
            />
          </div>
        </div>
        <p style={{ fontSize: 11, color: "var(--de-text-dim)", margin: "8px 0 0", lineHeight: 1.35 }}>
          Set city name or lat/lon. Data refreshes from OpenWeather every few minutes.
        </p>
      </div>

      <div className="de-rs-section">
        <span className="de-rs-section-label">Units</span>
        <div className="de-rs-scale-mode">
          <button
            type="button"
            className={`de-rs-scale-btn ${isMetric ? "active" : ""}`}
            onClick={() => onPatch({ unit: "metric" })}
          >
            {isMetric && <Check size={12} />} °C
          </button>
          <button
            type="button"
            className={`de-rs-scale-btn ${!isMetric ? "active" : ""}`}
            onClick={() => onPatch({ unit: "imperial" })}
          >
            {!isMetric && <Check size={12} />} °F
          </button>
        </div>
      </div>

      <div className="de-rs-section">
        <span className="de-rs-section-label">Appearance</span>
        {variant !== "minimal" && (
          <>
            {rowColor("Gradient A", "cardBg")}
            {rowColor("Gradient B", "cardBgEnd")}
          </>
        )}
        {variant === "minimal" && rowColor("Background", "cardBg")}
        {rowColor("Main text", "textColor")}
        {rowColor("Accent", "accentColor")}
        {variant !== "minimal" && rowColor("Meta text", "metaColor")}
      </div>
    </>
  );
}
